import styled, { css } from 'styled-components';
import { color } from '@nuvolo/nuux-theme/utils';

export const ACTIVE_COLOR = color('accent', 'middle');
export const INACTIVE_COLOR = color('contrast', 'light');
export const HOVER_COLOR = color('custom', 'hoverColor');
export const MENU_BACKGROUND_COLOR = color('custom', 'selected');
export const ACTIVE_MARKER_Z_INDEX = 9997;

const LIGHT_GRAY_COLOR = color('ui', 'light');
interface StylesProps {
  isDesktop: boolean;
  isCollapsed?: boolean;
}

const Styles = styled.div<StylesProps>`
  background-color: ${MENU_BACKGROUND_COLOR};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  ${({ isDesktop }) =>
    isDesktop &&
    css`
      padding: 12px;
    `}

  .menu-item-wrapper {
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    width: ${({ isDesktop, isCollapsed }) =>
      isDesktop ? (isCollapsed ? '60px' : '100%') : 'auto'};
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    div {
      &:hover {
        background-color: transparent;
      }

      ${({ isDesktop }) =>
        isDesktop &&
        css`
          &:hover {
            background-color: ${HOVER_COLOR};
          }
        `}
    }
  }

  .logo-wrapper > img {
    -webkit-user-drag: none;
  }
  .logout-button {
    &:hover {
      background-color: ${HOVER_COLOR};
    }
    span {
      color: ${LIGHT_GRAY_COLOR};
      fill: ${LIGHT_GRAY_COLOR};
    }
  }
`;

export default Styles;
